export const ContactsDetailViewStyle = {
  baseStyle: {
    flexDirection: { base: 'column', md: 'row' },
    flex: '1 0 0',
    height: { base: 'fit-content', md: '50%' },
    padding: { base: '0.5rem', lg: '1.25rem', xl: '2.5rem' },
    gap: { base: '0.5rem', lg: '1.25rem', xl: '2.5rem' },
    borderTop: '2px solid',
    borderColor: 'border.muted',
    overflowY: { base: 'scroll', md: 'visible' },
  },
}

export const useContactsDetailViewStyle = () => {
  return ContactsDetailViewStyle.baseStyle
}
